export enum ReportKeys {
  SafeStockNewCash = 'SafeStockNewCash',
  EmployeeSession = 'EmployeeSession',
  TransactionInvoice = 'TransactionInvoice',
  CustomerCreditCardBill = 'CustomerCreditCardBill',
  TicketInfo = 'TicketInfo',
  CustomerDelivery = 'CustomerDelivery',
  LastTransactionInvoice = 'LastTransactionInvoice'
}
